import React from 'react';
import {Col, Row, Tab, Table, Tabs} from "react-bootstrap";
import moment from "moment/moment";
import numberFormat from "../../../helpers/numberFormat";
import {showCount} from "../../../helpers/showCount";
import {standartBody, standartHead} from "./standartRacoonTable";

const AruanaKayarRender = ({data}) => {
  return (
    <div>
      <Row>
        <Col>
          <Tabs defaultActiveKey="correct">
            <Tab
              eventKey="correct"
              title={`Правильные (${data.correct.length})`}
            >
              <Table striped hover>
                {standartHead()}
                {standartBody(data.correct)}
              </Table>
            </Tab>
            <Tab
              eventKey="noIata"
              title={`Есть в Kayar но нет в Aruana (${showCount(data.aruanaMissing)})`}
            >
              <Table striped hover>
                {standartHead()}
                {standartBody(data.aruanaMissing)}
              </Table>
            </Tab>
            <Tab
              eventKey="noAruana"
              title={`Есть в Aruana но нет в Kayar (${showCount(data.kayarMissing)})`}
            >
              <Table striped hover>
                {standartHead()}
                {standartBody(data.kayarMissing)}
              </Table>
            </Tab>
            <Tab
              eventKey="diff"
              title={`Не соответствуют (${showCount(data.diff)})`}
            >
              <Table striped hover>
                <thead>
                <tr>
                  <td>Номер</td>
                  <td>Выписан Kayar</td>
                  <td>Выписан Aruana</td>
                  <td>Итого Kayar</td>
                  <td>Итого Aruana</td>
                </tr>
                </thead>
                <tbody>
                {data.diff.map((u, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {u.airline} {u.ticketNumber}
                      </td>
                      <td>{moment.utc(u.kayarIssueDate).format("DD.MM.YYYY")}</td>
                      <td>{moment.utc(u.issueDate).format("DD.MM.YYYY")}</td>
                      <td>{numberFormat(u.total.kayar)}</td>
                      <td>{numberFormat(u.total.aruana)}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td>
                    <b>Итого</b>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <b>
                      {numberFormat(
                        data.diff
                          .map(u => u.total.kayar)
                          .reduce((a, b) => a + b, 0)
                      )}
                    </b>
                  </td>
                  <td>
                    <b>
                      {numberFormat(
                        data.diff.map(u => u.total.aruana).reduce((a, b) => a + b, 0)
                      )}
                    </b>
                  </td>
                </tr>
                </tbody>
              </Table>
            </Tab>
          </Tabs>
        </Col>
      </Row>
      <Row>
        <Col>
          Сумма Kayar:{" "}
          <b>
            {numberFormat(data.kayarTotal)} (
            {numberFormat(data.kayarTotal - data.aruanaTotal)})
          </b>
          <br />
          Cумма Aruana:{" "}
          <b>
            {numberFormat(data.aruanaTotal)} (
            {numberFormat(data.aruanaTotal - data.kayarTotal)})
          </b>
          <br />
        </Col>
      </Row>
    </div>
  );
};

export default AruanaKayarRender;
